<script>
import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [
    Translatable
  ],
  props: {
    showModal: Boolean,
    text: {
      type: String,
      default: 'Thank you for your feedback!'
    },
    isButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('toggle', 'showFeedback')
    },
    onBtnClick() {
      this.$emit('emitFunc')
    },
  },
}
</script>

<template>
  <div class="app">
    <div class="modal-background" @click="onClick"></div>
    <div class="modal" >
      <div class="cross" @click="onClick"></div>
      <div class="text" v-html="text">
      </div>
      <div v-if="isButton" class="buttons-container">
        <div class="link">
          <button @click="onBtnClick" class="button-cancel">{{ 'Ok' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.app {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1098;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.modal-background {
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
}

.modal {
  background-color: $white;
  max-width: 650px;
  min-width: 200px;
  width: auto;
  min-height: 130px;
  height: auto;
  border-radius: 20px;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  z-index: 1100;
  padding: 30px;
}

::v-deep.text {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  // text-align: center;
  padding: 0 10px;

  & em {
    font-style: italic;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  & .ql-align-center {
    text-align: center;
  }
}

.cross {
  cursor: pointer;
  position: absolute;
  width: 24px;
  height: 24px;
  top: 8px;
  right: 8px;
  background: url("../../assets/icons/cross-small.svg") center no-repeat;
}

.link {
  display: block;
  outline: none;
  height: 48px;
}

.buttons-container {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.button-cancel {
  min-width: 175px;
  height: 48px;
  border: 1px solid $gray;
  border-radius: 5px;
  background: $white;
  color: $black;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  padding: 12px 30px;

  &:hover {
    border: 1px solid $white;
    height: 50px;
    background: $gray;
    color: $white;
  }
}

@media only screen and (max-width: $container-width-xs) {
  .modal {
    padding: 20px;
    max-width: 250px;
    width: auto;
  }
  ::v-deep.text {
    padding: 0 7px;
    & span {
      font-size: 14px !important;
    }
  }

  .buttons-container {
    display: flex;
    flex-direction: column;
    margin-top: 25px;
  }

  .link {
    margin: 0 0 15px;
  }

  .button-cancel {
    min-width: 100%;

    &:hover {
      border: 1px solid $gray;
      height: 48px;
      background: $white;
      color: $black;
    }

    &:active {
      border: 1px solid $white;
      height: 50px;
      background: $gray;
      color: $white;
    }
  }
}
</style>
